export default __webpack_public_path__ + "static/media/elasticsearch.2a09f01c.svg";